import { Controller } from "@hotwired/stimulus"

// Opens an action popover on hover or keyboard focus while preserving a
// click/tap trigger for touch devices.
export default class extends Controller {
  static targets = ["trigger", "panel"]

  disconnect() {
    this.cancelHide()
  }

  show() {
    this.cancelHide()
    if (!this.panelTarget.matches(":popover-open")) this.panelTarget.showPopover()
    this.positionPanel()
  }

  scheduleHide(event) {
    if (event.type === "focusout" && this.element.contains(event.relatedTarget)) return

    this.cancelHide()
    this.hideTimeout = setTimeout(() => this.hide(), 150)
  }

  activate(event) {
    event.preventDefault()
    this.show()
  }

  preservePanelInteraction(event) {
    event.stopPropagation()
    this.cancelHide()
  }

  hide() {
    if (this.panelTarget.matches(":popover-open")) this.panelTarget.hidePopover()
  }

  positionPanel() {
    const trigger = this.triggerTarget.getBoundingClientRect()
    const panel = this.panelTarget.getBoundingClientRect()
    const margin = 8
    const overlap = 2

    const left = Math.min(
      Math.max(margin, trigger.left),
      window.innerWidth - panel.width - margin
    )
    const below = trigger.bottom - overlap
    const top = below + panel.height <= window.innerHeight - margin
      ? below
      : Math.max(margin, trigger.top - panel.height + overlap)

    Object.assign(this.panelTarget.style, {
      position: "fixed",
      positionArea: "none",
      inset: "auto",
      margin: "0",
      left: `${left}px`,
      top: `${top}px`
    })
  }

  cancelHide() {
    if (!this.hideTimeout) return

    clearTimeout(this.hideTimeout)
    this.hideTimeout = null
  }
}
